import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 469.333 469.333' fill='none' className={className}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M234.667,362.667c-70.72,0-128-57.28-128-128c0-21.653,5.44-41.92,14.827-59.84L90.347,143.68 C73.813,170.133,64,201.173,64,234.667c0,94.293,76.373,170.667,170.667,170.667v64L320,384l-85.333-85.333V362.667z'
        fill={fillColor}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M234.667,64V0l-85.333,85.333l85.333,85.333v-64c70.72,0,128,57.28,128,128c0,21.653-5.44,41.92-14.827,59.84 l31.147,31.147c16.533-26.453,26.347-57.493,26.347-90.987C405.333,140.373,328.96,64,234.667,64z'
        fill={fillColor}
      />
    </svg>
  );
});

export default React.memo(Icon);
